import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import { ExtraRecipientsList } from './controls/ExtraRecipientsList';
import { MainLayout } from './MainLayout';


export const ExtraRecipients = () => {
  const usenavigate = useNavigate();
  useEffect(() => {
    let username = sessionStorage.getItem("username");
    if(username === '' || username === null) {
      usenavigate('/login');
    }
  });

  return (
      <MainLayout>
        <ExtraRecipientsList/>
      </MainLayout>
  );
};
